// extracted by mini-css-extract-plugin
export default {"root":"CategoryBrowseBackground-module__root___syy0c","datingBackground":"CategoryBrowseBackground-module__datingBackground___isY6V"};